import type { FullWidthImageComponent } from "../../types";
import { RuntimeImage } from "../../runtime/RendererRuntime";
import { getImageObjectPositionStyle, getImageOverrideProps, mergeClassNames, mergeStyles, resolveImageValue } from "../../utils/imageOptions";

/** Full-width image renderer with configurable positioning. */
export function FullWidthImageRenderer({ component }: { component: FullWidthImageComponent }) {
  const { src, alt, showLoadingCircle } = component.content;
  const { src: imageSrc, options } = resolveImageValue(src);
  const objectPositionStyle = getImageObjectPositionStyle(options);
  const overrideProps = getImageOverrideProps(options);
  if (!imageSrc?.trim()) {
    return null;
  }
  return (
    <section className="w-full overflow-hidden">
      <RuntimeImage
        src={imageSrc}
        alt={alt ?? ""}
        showLoadingCircle={showLoadingCircle === true || showLoadingCircle === "true"}
        className={mergeClassNames("w-full h-auto block", overrideProps.className)}
        style={mergeStyles(objectPositionStyle, overrideProps.style)}
        priority
      />
    </section>
  );
}
